import React from 'react';
import PropTypes from 'prop-types';

const MriSimmonsLogo = ({ height = 162, width = 828, mriColor = '#5f2167', simmonsColor = '#006098' }) => (
  <svg viewBox="0 0 828 162" style={{ height: `${height}px`, width: `${width}px` }}>
    <g id="MRI_SIMMONS_horizontal" data-name="MRI SIMMONS horizontal">
      <g id="COLOR-2" data-name="COLOR">
        <g id="SIMMONS">
          <path d="M411.44,59.24c0-11-5.12-17.62-16-17.62s-16.87,7.12-16.87,16c0,26.61,43.23,12,43.23,43.35,0,17.24-10.75,26.11-27,26.11-16.74,0-26-9-26-26.48V98h8v3.38c0,11.36,6,19,17.74,19,11.25,0,19.24-5.62,19.24-18.11,0-26.48-43.22-11.37-43.22-43.72,0-14,9.12-23.61,24.61-23.61,16.61,0,24.23,8.49,24.23,24.36Z" fill={simmonsColor} />
          <path d="M431.55,36.38h8v89.19h-8Z" fill={simmonsColor} />
          <path d="M453.53,36.38H467.4l21.48,79.2h.25l21.49-79.2h13.12v89.19h-8V43.87h-.25l-23.11,81.7h-7.49l-23.12-81.7h-.24v81.7h-8Z" fill={simmonsColor} />
          <path d="M538,36.38h13.87l21.48,79.2h.25l21.49-79.2h13.12v89.19h-8V43.87h-.25l-23.11,81.7h-7.49l-23.11-81.7H546v81.7h-8Z" fill={simmonsColor} />
          <path d="M649.39,34.88c18.24,0,28.49,14.11,28.49,46.09s-10.25,46.1-28.49,46.1S620.91,113,620.91,81,631.15,34.88,649.39,34.88Zm0,85.44c12.75,0,20.49-10.49,20.49-39.35s-7.74-39.35-20.49-39.35S628.91,52.12,628.91,81,636.65,120.32,649.39,120.32Z" fill={simmonsColor} />
          <path d="M689.86,36.38h10.75l34.1,77.7H735V36.38h8v89.19H732.21l-34.1-77.7h-.25v77.7h-8Z" fill={simmonsColor} />
          <path d="M794.79,59.24c0-11-5.12-17.62-16-17.62s-16.86,7.12-16.86,16c0,26.61,43.22,12,43.22,43.35,0,17.24-10.74,26.11-27,26.11-16.74,0-26-9-26-26.48V98h8v3.38c0,11.36,6,19,17.74,19,11.24,0,19.23-5.62,19.23-18.11,0-26.48-43.22-11.37-43.22-43.72,0-14,9.12-23.61,24.61-23.61,16.62,0,24.24,8.49,24.24,24.36Z" fill={simmonsColor} />
        </g>
        <rect x="325.27" y="88.13" width="5.4" height="57.6" fill={simmonsColor} />
        <rect x="324.88" y="16.14" width="5.4" height="57.6" fill={mriColor} />
        <g id="MRI">
          <path d="M22.36,36H62.1L75.05,88.93h.25L88.25,36H128v90H101.58V68.26h-.25L85.58,126H64.76L49,68.26h-.25V126H22.36Z" fill={mriColor} />
          <path d="M151.84,36H205c15.87,0,29.58,8.7,29.58,25.71,0,9.33-4.32,19.16-13.59,22.57,7.62,2.9,12.32,11.22,13.33,22.43.38,4.42.51,15.13,3,19.29H209.48a64.28,64.28,0,0,1-2.28-13.87c-.77-8.57-1.53-17.52-12.57-17.52H179.77V126H151.84Zm27.93,39.33h14.6c5.21,0,12.32-.88,12.32-8.95,0-5.67-3.18-9-13.84-9H179.77Z" fill={mriColor} />
          <path d="M255.43,36h27.93v90H255.43Z" fill={mriColor} />
        </g>
      </g>
    </g>
  </svg>
);

MriSimmonsLogo.propTypes = {
  mriColor: PropTypes.string,
  simmonsColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default MriSimmonsLogo;
